import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class ClayProductStatus extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        if (detail.newProduct) {
          this.dataset.productId = detail.newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const currentSku = this.section?.querySelector('clay-product-sku');
        const updatedSku = detail.html.querySelector('clay-product-sku');
        if (currentSku && updatedSku) morph(currentSku, updatedSku);

        const currentBadges = this.section?.querySelector('clay-product-badges');
        const updatedBadges = detail.html.querySelector('clay-product-badges');
        if (currentBadges && updatedBadges) morph(currentBadges, updatedBadges);

        const updatedStatus = detail.html.querySelector('clay-product-status');
        if (updatedStatus) morph(this, updatedStatus, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[clay-product-status] Update failed:', error);
      });
  };
}

if (!customElements.get('clay-product-status')) {
  customElements.define('clay-product-status', ClayProductStatus);
}
